function e(n) {
  return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(n);
}
function n(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function t(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function r(e) {
  for (var r = 1; r < arguments.length; r++) {
    var o = null != arguments[r] ? arguments[r] : {};
    r % 2 ? t(o, !0).forEach(function (t) {
      n(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : t(o).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(o, n));
    });
  }
  return e;
}
function o(e) {
  function n(e, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = n;
  }
  return n.prototype = new Error(), n.prototype.name = e, n.prototype.constructor = n, n;
}
var i = o("LaunchDarklyUnexpectedResponseError"),
  a = o("LaunchDarklyInvalidEnvironmentIdError"),
  u = o("LaunchDarklyInvalidUserError"),
  s = o("LaunchDarklyInvalidEventKeyError"),
  c = o("LaunchDarklyInvalidArgumentError"),
  l = o("LaunchDarklyFlagFetchError");
function f(e) {
  return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
}
for (var v = Object.freeze({
    __proto__: null,
    LDUnexpectedResponseError: i,
    LDInvalidEnvironmentIdError: a,
    LDInvalidUserError: u,
    LDInvalidEventKeyError: s,
    LDInvalidArgumentError: c,
    LDFlagFetchError: l,
    isHttpErrorRecoverable: f
  }), d = [], g = [], p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", m = 0, h = p.length; m < h; ++m) {
  d[m] = p[m], g[p.charCodeAt(m)] = m;
}
function y(e, n, t) {
  for (var r, o, i = [], a = n; a < t; a += 3) {
    r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(d[(o = r) >> 18 & 63] + d[o >> 12 & 63] + d[o >> 6 & 63] + d[63 & o]);
  }
  return i.join("");
}
g["-".charCodeAt(0)] = 62, g["_".charCodeAt(0)] = 63;
var w = Array.isArray,
  b = Object.keys,
  E = Object.prototype.hasOwnProperty,
  k = ["key", "secondary", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function S(e) {
  return function (e) {
    for (var n, t = e.length, r = t % 3, o = [], i = 0, a = t - r; i < a; i += 16383) {
      o.push(y(e, i, i + 16383 > a ? a : i + 16383));
    }
    return 1 === r ? (n = e[t - 1], o.push(d[n >> 2] + d[n << 4 & 63] + "==")) : 2 === r && (n = (e[t - 2] << 8) + e[t - 1], o.push(d[n >> 10] + d[n >> 4 & 63] + d[n << 2 & 63] + "=")), o.join("");
  }(function (e) {
    for (var n = [], t = 0; t < e.length; t++) {
      n.push(e.charCodeAt(t));
    }
    return n;
  }(unescape(encodeURIComponent(e))));
}
function D(e) {
  return S(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function P(e) {
  return JSON.parse(JSON.stringify(e));
}
function O(e, n) {
  return function e(n, t) {
    if (n === t) return !0;
    if (n && t && "object" == typeof n && "object" == typeof t) {
      var r,
        o,
        i,
        a = w(n),
        u = w(t);
      if (a && u) {
        if ((o = n.length) != t.length) return !1;
        for (r = o; 0 != r--;) {
          if (!e(n[r], t[r])) return !1;
        }
        return !0;
      }
      if (a != u) return !1;
      var s = n instanceof Date,
        c = t instanceof Date;
      if (s != c) return !1;
      if (s && c) return n.getTime() == t.getTime();
      var l = n instanceof RegExp,
        f = t instanceof RegExp;
      if (l != f) return !1;
      if (l && f) return n.toString() == t.toString();
      var v = b(n);
      if ((o = v.length) !== b(t).length) return !1;
      for (r = o; 0 != r--;) {
        if (!E.call(t, v[r])) return !1;
      }
      for (r = o; 0 != r--;) {
        if (!e(n[i = v[r]], t[i])) return !1;
      }
      return !0;
    }
    return n != n && t != t;
  }(e, n);
}
function U(e) {
  setTimeout(e, 0);
}
function R(e, n) {
  var t = e.then(function (e) {
    return n && setTimeout(function () {
      n(null, e);
    }, 0), e;
  }, function (e) {
    if (!n) return Promise.reject(e);
    setTimeout(function () {
      n(e, null);
    }, 0);
  });
  return n ? void 0 : t;
}
function j(e) {
  var n = {};
  for (var t in e) {
    C(e, t) && (n[t] = {
      value: e[t],
      version: 0
    });
  }
  return n;
}
function I(e) {
  var n = {};
  for (var t in e) {
    C(e, t) && (n[t] = e[t].value);
  }
  return n;
}
function T(e, n) {
  for (var t, r = n.slice(0), o = [], i = e; r.length > 0;) {
    for (t = []; i > 0;) {
      var a = r.shift();
      if (!a) break;
      (i -= D(JSON.stringify(a)).length) < 0 && t.length > 0 ? r.unshift(a) : t.push(a);
    }
    i = e, o.push(t);
  }
  return o;
}
function N(e) {
  var n = e.version || "3.2.10";
  return e.userAgent + "/" + n;
}
function L(e, n) {
  if (n && !n.sendLDHeaders) return {};
  var t = {
    "X-LaunchDarkly-User-Agent": N(e)
  };
  return n && n.wrapperName && (t["X-LaunchDarkly-Wrapper"] = n.wrapperVersion ? n.wrapperName + "/" + n.wrapperVersion : n.wrapperName), t;
}
function F() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
    n[t] = arguments[t];
  }
  return n.reduce(function (e, n) {
    return r({}, e, {}, n);
  }, {});
}
function C(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function x(e) {
  if (!e) return e;
  var n;
  for (var t in k) {
    var o = k[t],
      i = e[o];
    void 0 !== i && "string" != typeof i && ((n = n || r({}, e))[o] = String(i));
  }
  return n || e;
}
Object.freeze({
  __proto__: null,
  btoa: S,
  base64URLEncode: D,
  clone: P,
  deepEquals: O,
  onNextTick: U,
  wrapPromiseCallback: R,
  transformValuesToVersionedValues: j,
  transformVersionedValuesToValues: I,
  chunkUserEventsForUrl: T,
  getLDUserAgentString: N,
  getLDHeaders: L,
  extend: F,
  objectHasOwnProperty: C,
  sanitizeUser: x
});
for (var A = function (e, n) {
    return function (e) {
      var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
      if (n) {
        var t = new Uint8Array(16);
        e.exports = function () {
          return n(t), t;
        };
      } else {
        var r = new Array(16);
        e.exports = function () {
          for (var e, n = 0; n < 16; n++) {
            0 == (3 & n) && (e = 4294967296 * Math.random()), r[n] = e >>> ((3 & n) << 3) & 255;
          }
          return r;
        };
      }
    }(n = {
      exports: {}
    }), n.exports;
  }(), q = [], V = 0; V < 256; ++V) {
  q[V] = (V + 256).toString(16).substr(1);
}
var _,
  J,
  z = 0,
  M = 0,
  $ = function $(e, n, t) {
    var r = n && t || 0,
      o = n || [],
      i = (e = e || {}).node || _,
      a = void 0 !== e.clockseq ? e.clockseq : J;
    if (null == i || null == a) {
      var u = A();
      null == i && (i = _ = [1 | u[0], u[1], u[2], u[3], u[4], u[5]]), null == a && (a = J = 16383 & (u[6] << 8 | u[7]));
    }
    var s = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
      c = void 0 !== e.nsecs ? e.nsecs : M + 1,
      l = s - z + (c - M) / 1e4;
    if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || s > z) && void 0 === e.nsecs && (c = 0), c >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    z = s, M = c, J = a;
    var f = (1e4 * (268435455 & (s += 122192928e5)) + c) % 4294967296;
    o[r++] = f >>> 24 & 255, o[r++] = f >>> 16 & 255, o[r++] = f >>> 8 & 255, o[r++] = 255 & f;
    var v = s / 4294967296 * 1e4 & 268435455;
    o[r++] = v >>> 8 & 255, o[r++] = 255 & v, o[r++] = v >>> 24 & 15 | 16, o[r++] = v >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
    for (var d = 0; d < 6; ++d) {
      o[r + d] = i[d];
    }
    return n || function (e, n) {
      var t = n || 0,
        r = q;
      return [r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]]].join("");
    }(o);
  };
function H(e, n, t) {
  var r = "/a/" + n + ".gif",
    o = F({
      "Content-Type": "application/json"
    }, L(e, t)),
    i = e.httpFallbackPing,
    a = {
      sendChunk: function sendChunk(n, t, a, u) {
        var s = JSON.stringify(n),
          c = a ? null : $();
        return u ? function n(r) {
          var i = a ? o : F({}, o, {
            "X-LaunchDarkly-Event-Schema": "3",
            "X-LaunchDarkly-Payload-ID": c
          });
          return e.httpRequest("POST", t, i, s).promise.then(function (e) {
            if (e) return e.status >= 400 && f(e.status) && r ? n(!1) : function (e) {
              var n = {
                  status: e.status
                },
                t = e.header("date");
              if (t) {
                var r = Date.parse(t);
                r && (n.serverTime = r);
              }
              return n;
            }(e);
          }).catch(function () {
            return r ? n(!1) : Promise.reject();
          });
        }(!0).catch(function () {}) : (i && i(t + r + "?d=" + D(s)), Promise.resolve());
      },
      sendEvents: function sendEvents(n, t, r) {
        if (!e.httpRequest) return Promise.resolve();
        var o,
          i = e.httpAllowsPost();
        o = i ? [n] : T(2e3 - t.length, n);
        for (var u = [], s = 0; s < o.length; s++) {
          u.push(a.sendChunk(o[s], t, r, i));
        }
        return Promise.all(u);
      }
    };
  return a;
}
function K() {
  var e = {},
    n = 0,
    t = 0,
    r = {};
  return e.summarizeEvent = function (e) {
    if ("feature" === e.kind) {
      var o = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""),
        i = r[o];
      i ? i.count = i.count + 1 : r[o] = {
        count: 1,
        key: e.key,
        variation: e.variation,
        version: e.version,
        value: e.value,
        default: e.default
      }, (0 === n || e.creationDate < n) && (n = e.creationDate), e.creationDate > t && (t = e.creationDate);
    }
  }, e.getSummary = function () {
    var e = {},
      o = !0;
    for (var i in r) {
      var a = r[i],
        u = e[a.key];
      u || (u = {
        default: a.default,
        counters: []
      }, e[a.key] = u);
      var s = {
        value: a.value,
        count: a.count
      };
      void 0 !== a.variation && null !== a.variation && (s.variation = a.variation), a.version ? s.version = a.version : s.unknown = !0, u.counters.push(s), o = !1;
    }
    return o ? null : {
      startDate: n,
      endDate: t,
      features: e
    };
  }, e.clearSummary = function () {
    n = 0, t = 0, r = {};
  }, e;
}
function B(e) {
  var n = {},
    t = e.allAttributesPrivate,
    r = e.privateAttributeNames || [],
    o = {
      key: !0,
      custom: !0,
      anonymous: !0
    },
    i = {
      key: !0,
      secondary: !0,
      ip: !0,
      country: !0,
      email: !0,
      firstName: !0,
      lastName: !0,
      avatar: !0,
      name: !0,
      anonymous: !0,
      custom: !0
    };
  return n.filterUser = function (e) {
    if (!e) return null;
    var n = e.privateAttributeNames || [],
      a = function a(e, i) {
        return Object.keys(e).reduce(function (a, u) {
          var s = a;
          return i(u) && (function (e) {
            return !o[e] && (t || -1 !== n.indexOf(e) || -1 !== r.indexOf(e));
          }(u) ? s[1][u] = !0 : s[0][u] = e[u]), s;
        }, [{}, {}]);
      },
      u = a(e, function (e) {
        return i[e];
      }),
      s = u[0],
      c = u[1];
    if (e.custom) {
      var l = a(e.custom, function () {
        return !0;
      });
      s.custom = l[0], c = F({}, c, l[1]);
    }
    var f = Object.keys(c);
    return f.length && (f.sort(), s.privateAttrs = f), s;
  }, n;
}
function G(e) {
  return e && e.message ? e.message : "string" == typeof e || e instanceof String ? e : JSON.stringify(e);
}
var X = " Please see https://docs.launchdarkly.com/docs/js-sdk-reference#section-initializing-the-client for instructions on SDK initialization.",
  W = function W(e) {
    return 'Expected application/json content type but got "' + e + '"';
  },
  Q = function Q(e) {
    return "network error" + (e ? " (" + e + ")" : "");
  },
  Y = function Y(e) {
    return 'Custom event "' + e + '" does not exist';
  },
  Z = function Z() {
    return "Environment not found. Double check that you specified a valid environment/client-side ID." + X;
  },
  ee = function ee() {
    return "No environment/client-side ID was specified." + X;
  },
  ne = function ne(e) {
    return "Error fetching flag settings: " + G(e);
  },
  te = function te() {
    return "No user specified." + X;
  },
  re = function re() {
    return "Invalid user specified." + X;
  },
  oe = function oe() {
    return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + X;
  },
  ie = function ie(e, n) {
    return n ? '"' + e + '" is deprecated, please use "' + n + '"' : '"' + e + '" is deprecated';
  },
  ae = function ae(e, n, t) {
    return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + n + " - " + (f(e) ? t : "giving up permanently");
  },
  ue = function ue() {
    return "Cannot make HTTP requests in this environment." + X;
  },
  se = function se(e) {
    return "Opening stream connection to " + e;
  },
  ce = function ce(e, n) {
    return "Error on stream connection: " + G(e) + ", will continue retrying every " + n + " milliseconds.";
  },
  le = function le(e) {
    return 'Ignoring unknown config option "' + e + '"';
  },
  fe = function fe(e, n, t) {
    return 'Config option "' + e + '" should be of type ' + n + ", got " + t + ", using default value";
  },
  ve = function ve(e, n) {
    return 'Config option "' + e + '" should be a boolean, got ' + n + ", converting to boolean";
  },
  de = function de(e, n, t) {
    return 'Config option "' + e + '" was set to ' + n + ", changing to minimum value of " + t;
  },
  ge = function ge(e) {
    return "polling for feature flags at " + e;
  },
  pe = function pe(e) {
    return 'received streaming update for flag "' + e + '"';
  },
  me = function me(e) {
    return 'received streaming update for flag "' + e + '" but ignored due to version check';
  },
  he = function he(e) {
    return 'received streaming deletion for flag "' + e + '"';
  },
  ye = function ye(e) {
    return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
  },
  we = function we(e) {
    return 'enqueueing "' + e + '" event';
  },
  be = function be(e) {
    return "sending " + e + " events";
  },
  Ee = Object.freeze({
    __proto__: null,
    clientInitialized: function clientInitialized() {
      return "LaunchDarkly client initialized";
    },
    clientNotReady: function clientNotReady() {
      return "LaunchDarkly client is not ready";
    },
    eventCapacityExceeded: function eventCapacityExceeded() {
      return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
    },
    eventWithoutUser: function eventWithoutUser() {
      return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/docs/js-sdk-reference#section-analytics-events";
    },
    invalidContentType: W,
    invalidKey: function invalidKey() {
      return "Event key must be a string";
    },
    localStorageUnavailable: function localStorageUnavailable() {
      return "localStorage is unavailable";
    },
    localStorageUnavailableForUserId: function localStorageUnavailableForUserId() {
      return "localStorage is unavailable, so anonymous user ID cannot be cached";
    },
    networkError: Q,
    unknownCustomEventKey: Y,
    environmentNotFound: Z,
    environmentNotSpecified: ee,
    errorFetchingFlags: ne,
    userNotSpecified: te,
    invalidUser: re,
    bootstrapOldFormat: oe,
    bootstrapInvalid: function bootstrapInvalid() {
      return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
    },
    deprecated: ie,
    httpErrorMessage: ae,
    httpUnavailable: ue,
    identifyDisabled: function identifyDisabled() {
      return "identify() has no effect here; it must be called on the main client instance";
    },
    streamClosing: function streamClosing() {
      return "Closing stream connection";
    },
    streamConnecting: se,
    streamError: ce,
    unknownOption: le,
    wrongOptionType: fe,
    wrongOptionTypeBoolean: ve,
    optionBelowMinimum: de,
    debugPolling: ge,
    debugStreamPing: function debugStreamPing() {
      return "received ping message from stream";
    },
    debugStreamPut: function debugStreamPut() {
      return "received streaming update for all flags";
    },
    debugStreamPatch: pe,
    debugStreamPatchIgnored: me,
    debugStreamDelete: he,
    debugStreamDeleteIgnored: ye,
    debugEnqueueingEvent: we,
    debugPostingEvents: be,
    debugPostingDiagnosticEvent: function debugPostingDiagnosticEvent(e) {
      return "sending diagnostic event (" + e.kind + ")";
    }
  });
function ke(e, n, t, r, o) {
  var i = {};
  function a() {
    var e = "",
      o = r.getUser();
    return o && (e = t || S(JSON.stringify(o))), "ld:" + n + ":" + e;
  }
  return i.loadFlags = function () {
    return e.get(a()).then(function (e) {
      if (null == e) return null;
      try {
        var n = JSON.parse(e);
        if (n) {
          var t = n.$schema;
          void 0 === t || t < 1 ? n = j(n) : delete n.$schema;
        }
        return n;
      } catch (e) {
        return i.clearFlags().then(function () {
          return Promise.reject(e);
        });
      }
    }).catch(function (e) {
      return o.warn("localStorage is unavailable"), Promise.reject(e);
    });
  }, i.saveFlags = function (n) {
    var t = F({}, n, {
      $schema: 1
    });
    return e.set(a(), JSON.stringify(t)).catch(function (e) {
      return o.warn("localStorage is unavailable"), Promise.reject(e);
    });
  }, i.clearFlags = function () {
    return e.clear(a()).catch(function (e) {
      return o.warn("localStorage is unavailable"), Promise.reject(e);
    });
  }, i;
}
function Se(e, n, t, r) {
  var o,
    i = n.streamUrl,
    a = n.logger,
    u = {},
    s = i + "/eval/" + t,
    c = n.useReport,
    l = n.evaluationReasons,
    f = n.streamReconnectDelay,
    v = L(e, n),
    d = !1,
    g = null,
    p = null,
    m = null,
    h = null,
    y = null;
  function w(e) {
    d || (a.warn(ce(e, f)), d = !0), S(!1), k(), b(f);
  }
  function b(e) {
    p || (e ? p = setTimeout(E, e) : E());
  }
  function E() {
    var n;
    p = null;
    var r = "",
      u = {
        headers: v
      };
    if (e.eventSourceFactory) {
      for (var f in null != h && (r = "h=" + h), c ? e.eventSourceAllowsReport ? (n = s, u.method = "REPORT", u.headers["Content-Type"] = "application/json", u.body = JSON.stringify(m)) : (n = i + "/ping/" + t, r = "") : n = s + "/" + D(JSON.stringify(m)), l && (r = r + (r ? "&" : "") + "withReasons=true"), n = n + (r ? "?" : "") + r, k(), a.info(se(n)), o = new Date().getTime(), g = e.eventSourceFactory(n, u), y) {
        C(y, f) && g.addEventListener(f, y[f]);
      }
      g.onerror = w;
    }
  }
  function k() {
    g && (a.info("Closing stream connection"), g.close(), g = null);
  }
  function S(e) {
    o && r && r.recordStreamInit(o, !e, new Date().getTime() - o), o = null;
  }
  return u.connect = function (e, n, t) {
    m = e, h = n, y = {};
    var r = function r(e) {
      y[e] = function (n) {
        d = !1, S(!0), t[e] && t[e](n);
      };
    };
    for (var o in t || {}) {
      r(o);
    }
    b();
  }, u.disconnect = function () {
    clearTimeout(p), p = null, k();
  }, u.isConnected = function () {
    return !!(g && e.eventSourceIsActive && e.eventSourceIsActive(g));
  }, u;
}
function De(e, n, t) {
  var r = n.baseUrl,
    o = n.useReport,
    i = n.evaluationReasons,
    u = n.logger,
    s = {},
    c = {};
  function f(t, r) {
    if (!e.httpRequest) return new Promise(function (e, n) {
      n(new l(ue()));
    });
    var o = r ? "REPORT" : "GET",
      i = L(e, n);
    r && (i["Content-Type"] = "application/json");
    var u = c[t];
    u || (u = function (e) {
      var n,
        t,
        r,
        o,
        i = {
          addPromise: function addPromise(i, a) {
            n = i, t && t(), t = a, i.then(function (t) {
              n === i && (r(t), e && e());
            }, function (t) {
              n === i && (o(t), e && e());
            });
          }
        };
      return i.resultPromise = new Promise(function (e, n) {
        r = e, o = n;
      }), i;
    }(function () {
      delete c[t];
    }), c[t] = u);
    var s = e.httpRequest(o, t, i, r),
      f = s.promise.then(function (e) {
        if (200 === e.status) {
          if (e.header("content-type") && "application/json" === e.header("content-type").substring(0, "application/json".length)) return JSON.parse(e.body);
          var n = W(e.header("content-type") || "");
          return Promise.reject(new l(n));
        }
        return Promise.reject(function (e) {
          return 404 === e.status ? new a(Z()) : new l(ne(e.statusText || String(e.status)));
        }(e));
      }, function (e) {
        return Promise.reject(new l(Q(e)));
      });
    return u.addPromise(f, function () {
      s.cancel && s.cancel();
    }), u.resultPromise;
  }
  return s.fetchJSON = function (e) {
    return f(r + e, null);
  }, s.fetchFlagSettings = function (e, n) {
    var a,
      s,
      c,
      l = "";
    return o ? (s = [r, "/sdk/evalx/", t, "/user"].join(""), c = JSON.stringify(e)) : (a = D(JSON.stringify(e)), s = [r, "/sdk/evalx/", t, "/users/", a].join("")), n && (l = "h=" + n), i && (l = l + (l ? "&" : "") + "withReasons=true"), s = s + (l ? "?" : "") + l, u.debug(ge(s)), f(s, c);
  }, s;
}
function Pe(e, n) {
  var t = {
    validateUser: function validateUser(t) {
      if (!t) return Promise.reject(new u(te()));
      var r = P(t);
      return null !== r.key && void 0 !== r.key ? (r.key = r.key.toString(), Promise.resolve(r)) : r.anonymous ? (e ? e.get("ld:$anonUserId").catch(function () {
        return null;
      }) : Promise.resolve(null)).then(function (t) {
        if (t) return r.key = t, r;
        var o = $();
        return r.key = o, function (t) {
          return e ? e.set("ld:$anonUserId", t).catch(function () {
            n.warn("localStorage is unavailable, so anonymous user ID cannot be cached");
          }) : Promise.resolve();
        }(o).then(function () {
          return r;
        });
      }) : Promise.reject(new u(re()));
    }
  };
  return t;
}
var Oe = {
  baseUrl: {
    default: "https://app.launchdarkly.com"
  },
  streamUrl: {
    default: "https://clientstream.launchdarkly.com"
  },
  eventsUrl: {
    default: "https://events.launchdarkly.com"
  },
  sendEvents: {
    default: !0
  },
  streaming: {
    type: "boolean"
  },
  sendLDHeaders: {
    default: !0
  },
  inlineUsersInEvents: {
    default: !1
  },
  allowFrequentDuplicateEvents: {
    default: !1
  },
  sendEventsOnlyForVariation: {
    default: !1
  },
  useReport: {
    default: !1
  },
  evaluationReasons: {
    default: !1
  },
  eventCapacity: {
    default: 100,
    minimum: 1
  },
  flushInterval: {
    default: 2e3,
    minimum: 2e3
  },
  samplingInterval: {
    default: 0,
    minimum: 0
  },
  streamReconnectDelay: {
    default: 1e3,
    minimum: 0
  },
  allAttributesPrivate: {
    default: !1
  },
  privateAttributeNames: {
    default: []
  },
  bootstrap: {
    type: "string|object"
  },
  diagnosticRecordingInterval: {
    default: 9e5,
    minimum: 2e3
  },
  diagnosticOptOut: {
    default: !1
  },
  wrapperName: {
    type: "string"
  },
  wrapperVersion: {
    type: "string"
  },
  stateProvider: {
    type: "object"
  }
};
function Ue(n, t, r, o) {
  var i = F({
      logger: {
        default: o
      }
    }, Oe, r),
    a = {
      all_attributes_private: "allAttributesPrivate",
      private_attribute_names: "privateAttributeNames",
      samplingInterval: null
    };
  function u(e) {
    U(function () {
      t && t.maybeReportError(new c(e));
    });
  }
  var s = F({}, n || {});
  return function (e) {
    var n = e;
    Object.keys(a).forEach(function (e) {
      if (void 0 !== n[e]) {
        var t = a[e];
        o && o.warn(ie(e, t)), t && (void 0 === n[t] && (n[t] = n[e]), delete n[e]);
      }
    });
  }(s), function (n) {
    var t = F({}, n),
      r = function r(n) {
        if (null === n) return "any";
        if (void 0 !== n) {
          if (Array.isArray(n)) return "array";
          var t = e(n);
          return "boolean" === t || "string" === t || "number" === t || "function" === t ? t : "object";
        }
      };
    return Object.keys(n).forEach(function (e) {
      var o = n[e];
      if (null != o) {
        var a = i[e];
        if (void 0 === a) u(le(e));else {
          var s = a.type || r(a.default);
          if ("any" !== s) {
            var c = s.split("|"),
              l = r(o);
            c.indexOf(l) < 0 ? "boolean" === s ? (t[e] = !!o, u(ve(e, l))) : (u(fe(e, s, l)), t[e] = a.default) : "number" === l && void 0 !== a.minimum && o < a.minimum && (u(de(e, o, a.minimum)), t[e] = a.minimum);
          }
        }
      }
    }), t;
  }(s = function (e) {
    var n = F({}, e);
    return Object.keys(i).forEach(function (e) {
      void 0 !== n[e] && null !== n[e] || (n[e] = i[e] && i[e].default);
    }), n;
  }(s));
}
var Re = Object.freeze({
    __proto__: null,
    baseOptionDefs: Oe,
    validate: Ue
  }).baseOptionDefs,
  je = function je(e) {
    var n = {
      diagnosticId: $()
    };
    return e && (n.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), n;
  };
function Ie(e, n) {
  var t,
    r = ["debug", "info", "warn", "error"];
  t = null != n ? "" === n ? "" : n + " " : "LD: ";
  var o = 0;
  e && (o = "none" === e ? 100 : r.indexOf(e));
  var i = {};
  function a(e, n, i) {
    if (e >= o && console) {
      var a = console[n];
      if (a) {
        var u = e < r.length ? r[e] : "?";
        a.call(console, t + "[" + u + "] " + i);
      }
    }
  }
  return i.debug = function (e) {
    return a(0, "log", e);
  }, i.info = function (e) {
    return a(1, "info", e);
  }, i.warn = function (e) {
    return a(2, "warn", e);
  }, i.error = function (e) {
    return a(3, "error", e);
  }, i;
}
function Te(n, t, o, u, c) {
  var v,
    d,
    g,
    p,
    m = o && o.logger ? o.logger : c && c.logger && c.logger.default || Ie("warn"),
    h = function (e) {
      var n = {},
        t = {};
      return n.on = function (e, n, r) {
        t[e] = t[e] || [], t[e] = t[e].concat({
          handler: n,
          context: r
        });
      }, n.off = function (e, n, r) {
        if (t[e]) for (var o = 0; o < t[e].length; o++) {
          t[e][o].handler === n && t[e][o].context === r && (t[e] = t[e].slice(0, o).concat(t[e].slice(o + 1)));
        }
      }, n.emit = function (e) {
        if (t[e]) for (var n = t[e].slice(0), r = 0; r < n.length; r++) {
          n[r].handler.apply(n[r].context, Array.prototype.slice.call(arguments, 1));
        }
      }, n.getEvents = function () {
        return Object.keys(t);
      }, n.getEventListenerCount = function (e) {
        return t[e] ? t[e].length : 0;
      }, n.maybeReportError = function (n) {
        n && (t.error ? this.emit("error", n) : (e || console).error(n.message));
      }, n;
    }(m),
    y = function (e) {
      var n = !1,
        t = !1,
        r = null,
        o = null,
        i = new Promise(function (n) {
          e.on("ready", function t() {
            e.off("ready", t), n();
          });
        }).catch(function () {});
      return {
        getInitializationPromise: function getInitializationPromise() {
          return o || (n ? Promise.resolve() : t ? Promise.reject(r) : o = new Promise(function (n, t) {
            e.on("initialized", function t() {
              e.off("initialized", t), n();
            }), e.on("failed", function n(r) {
              e.off("failed", n), t(r);
            });
          }));
        },
        getReadyPromise: function getReadyPromise() {
          return i;
        },
        signalSuccess: function signalSuccess() {
          n || t || (n = !0, e.emit("initialized"), e.emit("ready"));
        },
        signalFailure: function signalFailure(o) {
          n || t || (t = !0, r = o, e.emit("failed", o), e.emit("ready")), e.maybeReportError(o);
        }
      };
    }(h),
    w = Ue(o, h, c, m),
    b = w.sendEvents,
    E = n,
    k = w.hash,
    S = H(u, E, w),
    D = w.sendEvents && !w.diagnosticOptOut,
    j = D ? je(E) : null,
    T = D ? function (e) {
      var n, t, r, o;
      function i(e) {
        n = e, t = 0, r = 0, o = [];
      }
      return i(e), {
        getProps: function getProps() {
          return {
            dataSinceDate: n,
            droppedEvents: t,
            eventsInLastBatch: r,
            streamInits: o
          };
        },
        setProps: function setProps(e) {
          n = e.dataSinceDate, t = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
        },
        incrementDroppedEvents: function incrementDroppedEvents() {
          t++;
        },
        setEventsInLastBatch: function setEventsInLastBatch(e) {
          r = e;
        },
        recordStreamInit: function recordStreamInit(e, n, t) {
          var r = {
            timestamp: e,
            failed: n,
            durationMillis: t
          };
          o.push(r);
        },
        reset: i
      };
    }(new Date().getTime()) : null,
    N = D ? function (e, n, t, o, i, a) {
      var u,
        s,
        c = !!e.diagnosticUseCombinedEvent,
        l = "ld:" + o + ":$diagnostics",
        f = i.eventsUrl + "/events/diagnostic/" + o,
        v = i.diagnosticRecordingInterval,
        d = n,
        g = !!i.streaming,
        p = {};
      function m() {
        return {
          sdk: w(),
          configuration: (n = {
            customBaseURI: i.baseUrl !== Re.baseUrl.default,
            customStreamURI: i.streamUrl !== Re.streamUrl.default,
            customEventsURI: i.eventsUrl !== Re.eventsUrl.default,
            eventsCapacity: i.eventCapacity,
            eventsFlushIntervalMillis: i.flushInterval,
            reconnectTimeMillis: i.streamReconnectDelay,
            streamingDisabled: !g,
            allAttributesPrivate: !!i.allAttributesPrivate,
            inlineUsersInEvents: !!i.inlineUsersInEvents,
            diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval,
            usingSecureMode: !!i.hash,
            bootstrapMode: !!i.bootstrap,
            fetchGoalsDisabled: !i.fetchGoals,
            allowFrequentDuplicateEvents: !!i.allowFrequentDuplicateEvents,
            sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation
          }, n),
          platform: e.diagnosticPlatformData
        };
        var n;
      }
      function h(e) {
        i.logger && i.logger.debug(Ee.debugPostingDiagnosticEvent(e)), t.sendEvents(e, f, !0).then(function () {}).catch(function () {});
      }
      function y() {
        var n, t;
        h((n = new Date().getTime(), t = r({
          kind: c ? "diagnostic-combined" : "diagnostic",
          id: a,
          creationDate: n
        }, d.getProps()), c && (t = r({}, t, {}, m())), d.reset(n), t)), s = setTimeout(y, v), u = new Date().getTime(), c && function () {
          if (e.localStorage) {
            var n = r({}, d.getProps());
            e.localStorage.set(l, JSON.stringify(n), function () {});
          }
        }();
      }
      function w() {
        var n = r({}, e.diagnosticSdkData);
        return i.wrapperName && (n.wrapperName = i.wrapperName), i.wrapperVersion && (n.wrapperVersion = i.wrapperVersion), n;
      }
      return p.start = function () {
        c ? function (n) {
          if (!e.localStorage) return n(!1);
          e.localStorage.get(l).then(function (e) {
            if (e) try {
              var t = JSON.parse(e);
              d.setProps(t), u = t.dataSinceDate;
            } catch (e) {}
            n(!0);
          }).catch(function () {
            n(!1);
          });
        }(function (e) {
          if (e) {
            var n = (u || 0) + v,
              t = new Date().getTime();
            t >= n ? y() : s = setTimeout(y, n - t);
          } else 0 === Math.floor(4 * Math.random()) ? y() : s = setTimeout(y, v);
        }) : (h(r({
          kind: "diagnostic-init",
          id: a,
          creationDate: d.getProps().dataSinceDate
        }, m())), s = setTimeout(y, v));
      }, p.stop = function () {
        s && clearTimeout(s);
      }, p.setStreaming = function (e) {
        g = e;
      }, p;
    }(u, T, S, E, w, j) : null,
    L = Se(u, w, E, T),
    A = w.eventProcessor || function (e, n, t) {
      var r,
        o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
        a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
        u = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
        s = {},
        c = u || H(e, t, n),
        l = n.eventsUrl + "/events/bulk/" + t,
        v = K(),
        d = B(n),
        g = n.inlineUsersInEvents,
        p = n.samplingInterval,
        m = n.eventCapacity,
        h = n.flushInterval,
        y = n.logger,
        w = [],
        b = 0,
        E = !1,
        k = !1;
      function S() {
        return 0 === p || 0 === Math.floor(Math.random() * p);
      }
      function D(e) {
        return !!e.debugEventsUntilDate && e.debugEventsUntilDate > b && e.debugEventsUntilDate > new Date().getTime();
      }
      function P(e) {
        var n = F({}, e);
        return g || "identify" === e.kind ? n.user = d.filterUser(e.user) : (n.userKey = e.user.key, delete n.user), "feature" === e.kind && (delete n.trackEvents, delete n.debugEventsUntilDate), n;
      }
      function O(e) {
        w.length < m ? (w.push(e), k = !1) : (k || (k = !0, y.warn("Exceeded event queue capacity. Increase capacity to avoid dropping events.")), o && o.incrementDroppedEvents());
      }
      return s.enqueue = function (e) {
        if (!E) {
          var n = !1,
            t = !1;
          if (v.summarizeEvent(e), "feature" === e.kind ? S() && (n = !!e.trackEvents, t = D(e)) : n = S(), n && O(P(e)), t) {
            var r = F({}, e, {
              kind: "debug"
            });
            delete r.trackEvents, delete r.debugEventsUntilDate, delete r.variation, O(r);
          }
        }
      }, s.flush = function () {
        if (E) return Promise.resolve();
        var e = w,
          n = v.getSummary();
        return v.clearSummary(), n && (n.kind = "summary", e.push(n)), o && o.setEventsInLastBatch(e.length), 0 === e.length ? Promise.resolve() : (w = [], y.debug(be(e.length)), c.sendEvents(e, l).then(function (e) {
          e && (e.serverTime && (b = e.serverTime), f(e.status) || (E = !0), e.status >= 400 && U(function () {
            a.maybeReportError(new i(ae(e.status, "event posting", "some events were dropped")));
          }));
        }));
      }, s.start = function () {
        r = setTimeout(function e() {
          s.flush(), r = setTimeout(e, h);
        }, h);
      }, s.stop = function () {
        clearTimeout(r);
      }, s;
    }(u, w, E, T, h, S),
    q = De(u, w, E),
    V = {},
    _ = {},
    J = w.streaming,
    z = !1,
    M = !1,
    $ = !0,
    G = w.stateProvider,
    X = function (e, n) {
      var t,
        r = {
          setUser: function setUser(e) {
            (t = x(e)) && n && n(P(t));
          },
          getUser: function getUser() {
            return t ? P(t) : null;
          }
        };
      return r;
    }(0, function (e) {
      G || e && Q({
        kind: "identify",
        key: e.key,
        user: e,
        creationDate: new Date().getTime()
      });
    }),
    W = Pe(u.localStorage, m);
  function Q(e) {
    E && (G && G.enqueueEvent && G.enqueueEvent(e) || (e.user ? ($ = !1, !b || M || u.isDoNotTrack() || (m.debug(we(e.kind)), A.enqueue(e))) : $ && (m.warn("Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/docs/js-sdk-reference#section-analytics-events"), $ = !1)));
  }
  function Z(e, n, t, r) {
    var o = X.getUser(),
      i = new Date(),
      a = n ? n.value : null;
    if (!w.allowFrequentDuplicateEvents) {
      var u = JSON.stringify(a) + (o && o.key ? o.key : "") + e,
        s = V[u];
      if (s && i - s < 3e5) return;
      V[u] = i;
    }
    var c = {
        kind: "feature",
        key: e,
        user: o,
        value: a,
        variation: n ? n.variationIndex : null,
        default: t,
        creationDate: i.getTime()
      },
      l = _[e];
    l && (c.version = l.flagVersion ? l.flagVersion : l.version, c.trackEvents = l.trackEvents, c.debugEventsUntilDate = l.debugEventsUntilDate), (r || l && l.trackReason) && n && (c.reason = n.reason), Q(c);
  }
  function te(e, n, t, r) {
    var o;
    if (_ && C(_, e) && _[e] && !_[e].deleted) {
      var i = _[e];
      o = re(i), null !== i.value && void 0 !== i.value || (o.value = n);
    } else o = {
      value: n,
      variationIndex: null,
      reason: {
        kind: "ERROR",
        errorKind: "FLAG_NOT_FOUND"
      }
    };
    return t && Z(e, o, n, r), o;
  }
  function re(e) {
    return {
      value: e.value,
      variationIndex: void 0 === e.variation ? null : e.variation,
      reason: e.reason || null
    };
  }
  function ie() {
    d = !0, X.getUser() && L.connect(X.getUser(), k, {
      ping: function ping() {
        m.debug("received ping message from stream");
        var e = X.getUser();
        q.fetchFlagSettings(e, k).then(function (n) {
          O(e, X.getUser()) && se(n || {});
        }).catch(function (e) {
          h.maybeReportError(new l(ne(e)));
        });
      },
      put: function put(e) {
        var n = JSON.parse(e.data);
        m.debug("received streaming update for all flags"), se(n);
      },
      patch: function patch(e) {
        var n = JSON.parse(e.data),
          t = _[n.key];
        if (!t || !t.version || !n.version || t.version < n.version) {
          m.debug(pe(n.key));
          var r = {},
            o = F({}, n);
          delete o.key, _[n.key] = o;
          var i = re(o);
          r[n.key] = t ? {
            previous: t.value,
            current: i
          } : {
            current: i
          }, ce(r);
        } else m.debug(me(n.key));
      },
      delete: function _delete(e) {
        var n = JSON.parse(e.data);
        if (!_[n.key] || _[n.key].version < n.version) {
          m.debug(he(n.key));
          var t = {};
          _[n.key] && !_[n.key].deleted && (t[n.key] = {
            previous: _[n.key].value
          }), _[n.key] = {
            version: n.version,
            deleted: !0
          }, ce(t);
        } else m.debug(ye(n.key));
      }
    });
  }
  function ue() {
    d && (L.disconnect(), d = !1);
  }
  function se(e) {
    var n = {};
    if (!e) return Promise.resolve();
    for (var t in _) {
      C(_, t) && _[t] && (e[t] && !O(e[t].value, _[t].value) ? n[t] = {
        previous: _[t].value,
        current: re(e[t])
      } : e[t] && !e[t].deleted || (n[t] = {
        previous: _[t].value
      }));
    }
    for (var o in e) {
      C(e, o) && e[o] && (!_[o] || _[o].deleted) && (n[o] = {
        current: re(e[o])
      });
    }
    return _ = r({}, e), ce(n).catch(function () {});
  }
  function ce(e) {
    var n = Object.keys(e);
    if (n.length > 0) {
      var t = {};
      n.forEach(function (n) {
        var r = e[n].current,
          o = r ? r.value : void 0,
          i = e[n].previous;
        h.emit("change:" + n, o, i), t[n] = r ? {
          current: o,
          previous: i
        } : {
          previous: i
        };
      }), h.emit("change", t), h.emit("internal-change", _), w.sendEventsOnlyForVariation || G || n.forEach(function (n) {
        Z(n, e[n].current);
      });
    }
    return v && p ? p.saveFlags(_).catch(function () {
      return null;
    }) : Promise.resolve();
  }
  function le() {
    var e = J || g && void 0 === J;
    e && !d ? ie() : !e && d && ue(), N && N.setStreaming(e);
  }
  function fe(e) {
    return "change" === e || "change:" === e.substr(0, "change".length + 1);
  }
  if (u.localStorage && (p = new ke(u.localStorage, E, k, X, m)), "string" == typeof w.bootstrap && "LOCALSTORAGE" === w.bootstrap.toUpperCase() && (p ? v = !0 : m.warn("localStorage is unavailable")), "object" === e(w.bootstrap) && (_ = function (e) {
    var n = Object.keys(e),
      t = e.$flagsState;
    !t && n.length && m.warn(oe()), !1 === e.$valid && m.warn("LaunchDarkly bootstrap data is not available because the back end could not read the flags.");
    var r = {};
    return n.forEach(function (n) {
      if ("$flagsState" !== n && "$valid" !== n) {
        var o = {
          value: e[n]
        };
        t && t[n] ? o = F(o, t[n]) : o.version = 0, r[n] = o;
      }
    }), r;
  }(w.bootstrap)), G) {
    var ve = G.getInitialState();
    ve ? de(ve) : G.on("init", de), G.on("update", function (e) {
      e.user && X.setUser(e.user), e.flags && se(e.flags);
    });
  } else (n ? W.validateUser(t).then(function (n) {
    return X.setUser(n), "object" === e(w.bootstrap) ? ge() : v ? p.loadFlags().catch(function () {
      return null;
    }).then(function (e) {
      return null == e ? (_ = {}, q.fetchFlagSettings(X.getUser(), k).then(function (e) {
        return se(e || {});
      }).then(ge).catch(function (e) {
        Oe(new l(ne(e)));
      })) : (_ = e, U(ge), q.fetchFlagSettings(X.getUser(), k).then(function (e) {
        return se(e);
      }).catch(function (e) {
        return h.maybeReportError(e);
      }));
    }) : q.fetchFlagSettings(X.getUser(), k).then(function (e) {
      _ = e || {}, ge();
    }).catch(function (e) {
      _ = {}, Oe(e);
    });
  }) : Promise.reject(new a(ee()))).catch(Oe);
  function de(e) {
    E = e.environment, X.setUser(e.user), _ = r({}, e.flags), U(ge);
  }
  function ge() {
    m.info("LaunchDarkly client initialized"), z = !0, le(), y.signalSuccess();
  }
  function Oe(e) {
    y.signalFailure(e);
  }
  return {
    client: {
      waitForInitialization: function waitForInitialization() {
        return y.getInitializationPromise();
      },
      waitUntilReady: function waitUntilReady() {
        return y.getReadyPromise();
      },
      identify: function identify(e, n, t) {
        return M ? R(Promise.resolve({}), t) : G ? (m.warn("identify() has no effect here; it must be called on the main client instance"), R(Promise.resolve(I(_)), t)) : R((v && p ? p.clearFlags() : Promise.resolve()).then(function () {
          return W.validateUser(e);
        }).then(function (e) {
          return q.fetchFlagSettings(e, n).then(function (t) {
            var r = I(t);
            return X.setUser(e), k = n, t ? se(t).then(function () {
              return r;
            }) : r;
          });
        }).then(function (e) {
          return d && ie(), e;
        }).catch(function (e) {
          return h.maybeReportError(e), Promise.reject(e);
        }), t);
      },
      getUser: function getUser() {
        return X.getUser();
      },
      variation: function variation(e, n) {
        return te(e, n, !0, !1).value;
      },
      variationDetail: function variationDetail(e, n) {
        return te(e, n, !0, !0);
      },
      track: function track(e, n, t) {
        if ("string" == typeof e) {
          u.customEventFilter && !u.customEventFilter(e) && m.warn(Y(e));
          var r = {
            kind: "custom",
            key: e,
            user: X.getUser(),
            url: u.getCurrentUrl(),
            creationDate: new Date().getTime()
          };
          null != n && (r.data = n), null != t && (r.metricValue = t), Q(r);
        } else h.maybeReportError(new s(Y(e)));
      },
      on: function on(e, n, t) {
        fe(e) ? (g = !0, z && le(), h.on(e, n, t)) : h.on.apply(h, arguments);
      },
      off: function off(e) {
        if (h.off.apply(h, arguments), fe(e)) {
          var n = !1;
          h.getEvents().forEach(function (e) {
            fe(e) && h.getEventListenerCount(e) > 0 && (n = !0);
          }), n || (g = !1, d && void 0 === J && ue());
        }
      },
      setStreaming: function setStreaming(e) {
        var n = null === e ? void 0 : e;
        n !== J && (J = n, le());
      },
      flush: function flush(e) {
        return R(b ? A.flush() : Promise.resolve(), e);
      },
      allFlags: function allFlags() {
        var e = {};
        if (!_) return e;
        for (var n in _) {
          C(_, n) && (e[n] = te(n, null, !w.sendEventsOnlyForVariation).value);
        }
        return e;
      },
      close: function close(e) {
        if (M) return R(Promise.resolve(), e);
        var n = function n() {
          M = !0, _ = {};
        };
        return R(Promise.resolve().then(function () {
          if (ue(), N && N.stop(), b) return A.stop(), A.flush();
        }).then(n).catch(n), e);
      }
    },
    options: w,
    emitter: h,
    ident: X,
    logger: m,
    requestor: q,
    start: function start() {
      b && (N && N.start(), A.start());
    },
    enqueueEvent: Q,
    getFlagsInternal: function getFlagsInternal() {
      return _;
    },
    getEnvironmentId: function getEnvironmentId() {
      return E;
    },
    internalChangeEventName: "internal-change"
  };
}
function Ne(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function Le(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Fe(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2 ? Le(Object(t), !0).forEach(function (n) {
      Ne(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Le(Object(t)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
var Ce = {
  promise: Promise.resolve({
    status: 200,
    header: function header() {
      return null;
    },
    body: null
  })
};
function xe(e, n, t, r, o) {
  if (o && !function () {
    var e = window.navigator && window.navigator.userAgent;
    if (e) {
      var n = e.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (n) return parseInt(n[2], 10) < 73;
    }
    return !0;
  }()) return Ce;
  var i = new window.XMLHttpRequest();
  for (var a in i.open(e, n, !o), t || {}) {
    Object.prototype.hasOwnProperty.call(t, a) && i.setRequestHeader(a, t[a]);
  }
  if (o) return i.send(r), Ce;
  var u;
  return {
    promise: new Promise(function (e, n) {
      i.addEventListener("load", function () {
        u || e({
          status: i.status,
          header: function header(e) {
            return i.getResponseHeader(e);
          },
          body: i.responseText
        });
      }), i.addEventListener("error", function () {
        u || n(new Error());
      }), i.send(r);
    }),
    cancel: function cancel() {
      u = !0, i.abort();
    }
  };
}
function Ae(e) {
  var n,
    t = {
      synchronousFlush: !1
    };
  if (window.XMLHttpRequest) {
    var r = e && e.disableSyncEventPost;
    t.httpRequest = function (e, n, o, i) {
      var a = t.synchronousFlush & !r;
      return t.synchronousFlush = !1, xe(e, n, o, i, a);
    };
  }
  t.httpAllowsPost = function () {
    return void 0 === n && (n = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), n;
  }, t.httpFallbackPing = function (e) {
    new window.Image().src = e;
  };
  var o,
    i = e && e.eventUrlTransformer;
  t.getCurrentUrl = function () {
    return i ? i(window.location.href) : window.location.href;
  }, t.isDoNotTrack = function () {
    var e;
    return 1 === (e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === e || "1" === e || "yes" === e;
  };
  try {
    window.localStorage && (t.localStorage = {
      get: function get(e) {
        return new Promise(function (n) {
          n(window.localStorage.getItem(e));
        });
      },
      set: function set(e, n) {
        return new Promise(function (t) {
          window.localStorage.setItem(e, n), t();
        });
      },
      clear: function clear(e) {
        return new Promise(function (n) {
          window.localStorage.removeItem(e), n();
        });
      }
    });
  } catch (e) {
    t.localStorage = null;
  }
  if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (t.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (t.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
    var a = 3e5;
    t.eventSourceFactory = function (e, n) {
      var t = Fe(Fe({}, {
        heartbeatTimeout: a,
        silentTimeout: a,
        skipDefaultHeaders: !0
      }), n);
      return new o(e, t);
    }, t.eventSourceIsActive = function (e) {
      return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
    };
  }
  return t.userAgent = "JSClient", t.version = "2.18.1", t.diagnosticSdkData = {
    name: "js-client-sdk",
    version: "2.18.1"
  }, t.diagnosticPlatformData = {
    name: "JS"
  }, t.diagnosticUseCombinedEvent = !0, t;
}
var qe = /[|\\{}()[\]^$+*?.]/g,
  Ve = function Ve(e) {
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(qe, "\\$&");
  };
function _e(e, n, t, r) {
  var o,
    i,
    a = n.replace(t, "").replace(r, "");
  switch (e.kind) {
    case "exact":
      i = n, o = new RegExp("^" + Ve(e.url) + "/?$");
      break;
    case "canonical":
      i = a, o = new RegExp("^" + Ve(e.url) + "/?$");
      break;
    case "substring":
      i = a, o = new RegExp(".*" + Ve(e.substring) + ".*$");
      break;
    case "regex":
      i = a, o = new RegExp(e.pattern);
      break;
    default:
      return !1;
  }
  return o.test(i);
}
function Je(e, n) {
  for (var t = {}, r = null, o = [], i = 0; i < e.length; i++) {
    for (var a = e[i], u = a.urls || [], s = 0; s < u.length; s++) {
      if (_e(u[s], window.location.href, window.location.search, window.location.hash)) {
        "pageview" === a.kind ? n("pageview", a) : (o.push(a), n("click_pageview", a));
        break;
      }
    }
  }
  return o.length > 0 && (r = function r(e) {
    for (var t = function (e, n) {
        for (var t = [], r = 0; r < n.length; r++) {
          for (var o = e.target, i = n[r], a = i.selector, u = document.querySelectorAll(a); o && u.length > 0;) {
            for (var s = 0; s < u.length; s++) {
              o === u[s] && t.push(i);
            }
            o = o.parentNode;
          }
        }
        return t;
      }(e, o), r = 0; r < t.length; r++) {
      n("click", t[r]);
    }
  }, document.addEventListener("click", r)), t.dispose = function () {
    document.removeEventListener("click", r);
  }, t;
}
function ze(e, n) {
  var t,
    r,
    o = {};
  function i() {
    r && r.dispose(), t && t.length && (r = Je(t, a));
  }
  function a(n, t) {
    var r = {
      kind: n,
      key: t.key,
      data: null,
      url: window.location.href,
      user: e.ident.getUser(),
      creationDate: new Date().getTime()
    };
    return "click" === n && (r.selector = t.selector), e.enqueueEvent(r);
  }
  return o.goalKeyExists = function (e) {
    if (!t) return !0;
    for (var n = 0; n < t.length; n++) {
      if ("custom" === t[n].kind && t[n].key === e) return !0;
    }
    return !1;
  }, e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function (e) {
    e && e.length > 0 && (r = Je(t = e, a), function (e, n) {
      var t,
        r = window.location.href;
      function o() {
        (t = window.location.href) !== r && (r = t, n());
      }
      !function e(n, t) {
        n(), setTimeout(function () {
          e(n, t);
        }, t);
      }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
    }(300, i)), n();
  }).catch(function (t) {
    e.emitter.maybeReportError(new v.LDUnexpectedResponseError((t && t.message, t.message))), n();
  }), o;
}
var Me = {
  fetchGoals: {
    default: !0
  },
  hash: {
    type: "string"
  },
  eventProcessor: {
    type: "object"
  },
  eventUrlTransformer: {
    type: "function"
  },
  disableSyncEventPost: {
    default: !1
  }
};
function $e(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    r = Ae(t),
    o = Te(e, n, t, r, Me),
    i = o.client,
    a = o.options,
    u = o.emitter,
    s = new Promise(function (e) {
      var n = u.on("goalsReady", function () {
        u.off("goalsReady", n), e();
      });
    });
  if (i.waitUntilGoalsReady = function () {
    return s;
  }, a.fetchGoals) {
    var c = ze(o, function () {
      return u.emit("goalsReady");
    });
    r.customEventFilter = c.goalKeyExists;
  } else u.emit("goalsReady");
  "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();
  var l = function l() {
    r.synchronousFlush = !0, i.flush().catch(function () {}), r.synchronousFlush = !1;
  };
  return window.addEventListener("beforeunload", l), window.addEventListener("unload", l), i;
}
var He = Ie,
  Ke = "2.18.1";
var Be = {
  initialize: function initialize(e, n) {
    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return console && console.warn && console.warn(Ee.deprecated("default export", "named LDClient export")), $e(e, n, t);
  },
  version: "2.18.1"
};
export default Be;
export { He as createConsoleLogger, $e as initialize, Ke as version };